module.exports = __webpack_public_path__ + "static/media/img_35.0917c07a.png";